export default __webpack_public_path__ + "static/media/Ring of Swift Storms.6e23bf62.jpg";